// extracted by mini-css-extract-plugin
export default {"actions":"CardActions_actions__nEKKH","like":"CardActions_like__5lS0b","liked":"CardActions_liked__0ctgs"};